import { useState, useEffect } from 'react';
import axios from 'axios';
import { base_url } from '../baseUrl';

const useDashboardItems = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchDashboardItems = async () => {
      setLoading(true);
      setError(null);

      try {
        const { data } = await axios.get(`${base_url}api/zoho/dashboard-items`);
        setItems(data.items || []);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchDashboardItems();
  }, []);

  return { items, loading, error };
};

export default useDashboardItems;
